import Link from 'next/link'

import { Button } from '@/components/custom/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

import type { EdunodesCommunitySummary } from '@/constant/edunodes'
import { EDUNODES_HOME_URL } from '@/constant/edunodes'

type EdunodesJoinCommunityDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  community: EdunodesCommunitySummary
  email: string
  onConfirm: () => void | Promise<void>
  isLoading?: boolean
}

export function EdunodesJoinCommunityDialog({
  open,
  onOpenChange,
  community,
  email,
  onConfirm,
  isLoading = false,
}: EdunodesJoinCommunityDialogProps) {
  const communityName = community.name?.trim() || community.subdomain

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Join this community?</DialogTitle>
          <DialogDescription className="text-left leading-relaxed text-slate-600">
            You already have an Edunodes account ({email}). Would you like to join{' '}
            <span className="font-semibold text-foreground">{communityName}</span>? This
            community is a member of{' '}
            <a
              href={EDUNODES_HOME_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-blue-700 underline-offset-2 hover:underline"
            >
              Edunodes
            </a>
            .
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col sm:space-x-0">
          <Button type="button" loading={isLoading} onClick={() => void onConfirm()}>
            Join community
          </Button>
          <Button
            type="button"
            variant="outline"
            disabled={isLoading}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <p className="text-center text-xs text-muted-foreground">
            <Link
              href="/auth/forgot-password"
              className="font-medium underline-offset-2 hover:underline"
            >
              Forgot password?
            </Link>
          </p>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
